<div class="modal-content">
  <topic-form
    [isEditMode]="isEditMode"
    [data]="item"
    (processCompleted)="onProcessCompleted($event)"></topic-form>
</div>
